import { config } from './config';
import { handleLoginRedirect, startApplication } from './configuration/login';

if (window.location.href.startsWith(config.login.redirectUri)) {
    handleLoginRedirect();
} else if (config.enableAppStart) {
    startApplication();
}
